import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Alert from '../UI/Alert/Alert';

// provider
import { useStore } from "../../providers/App/Store/StoreProvider";

const NewStoreDialog = ({open, handleClose}) => {
    // global
    const { createNewStore } = useStore();

    // local
    const [newStoreName, setNewStoreName] = React.useState('');
    const [newStoreURL, setNewStoreURL] = React.useState('');
    const [newStoreAPIKey, setNewStoreAPIKey] = React.useState('');
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState('');

    const useStyles = makeStyles(() => ({
        alert: {
            position: "fixed",
            top: "15%",
            left: "50%",
            transform: "translateX(-50%)"
        }
    }));
    const classes = useStyles()

    const handleCreate = async () => {
        try{
            await createNewStore(newStoreName, newStoreURL, newStoreAPIKey);
            setSuccess(`Store '${newStoreName}' created successfully`);
            handleClose();
        }
        catch(err){
            setError(err.message)
            console.error(err)
        }
    }

    React.useEffect(() => {
        if(error || success){
            window.setTimeout(
                () => {
                    setError('');
                    setSuccess('');
                },
                4500
            );
        }
    }, [error, success]);

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="new-store-dialog-title"
            >
                <DialogTitle id="new-store-dialog-title">Create a store</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        To create a new store, please enter the name of the store here.
                    </DialogContentText>
                    <TextField
                        margin="dense"
                        label="Store Name"
                        type="text"
                        fullWidth
                        value={newStoreName}
                        onChange={(e) => setNewStoreName(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Store URL"
                        type="url"
                        fullWidth
                        value={newStoreURL}
                        onChange={(e) => setNewStoreURL(e.target.value)}
                    />
                    <TextField
                        margin="dense"
                        label="Store API Key"
                        type="text"
                        fullWidth
                        value={newStoreAPIKey}
                        onChange={(e) => setNewStoreAPIKey(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleCreate} color="primary">
                        Create
                    </Button>
                </DialogActions>
            </Dialog>
        {
            error || success
            ?
            <Alert
                className={classes.alert}
                severity={error?"error":"success"}
                title={error?"Error":"Success"}
                message={error || success}
            />
            :
            null
        }
        </>
    );
};

export default NewStoreDialog;